import { ToastData, reduxToastAction } from "../types";

export const updateToast = (data: ToastData): reduxToastAction => {
  return {
    type: "UPDATE_TOAST",
    payload: data
  };
};
